export default __webpack_public_path__ + "static/media/tv.32fa5f9c.svg";